import {
  ActivatedRouteSnapshot,
  ResolveFn,
} from '@angular/router';
import { ReportFormStore } from '../reports/services';
import { inject } from '@angular/core';
import { EquipmentTabDto, GeneralTabDto } from '@fdm/api-client';

export const reportFormResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => {
  const store = inject(ReportFormStore);
  const id = route.paramMap.get('id')!;
  //   const general = toSignal(store.general$)

  store.restore();
  store.setGeneral(GeneralTabDto.fromJS({ id }));

  try {
    const key = `fdm:equipment-draft:${id}`;
    const raw = sessionStorage.getItem(key);

    if (raw) {
      const draft = EquipmentTabDto.fromJS(JSON.parse(raw));
      store.setEquipment(draft);
    }
  } catch {
    // noop
  }

  return id;
};
